import { type ClassValue } from 'clsx';

export const selectStyles: Record<string, ClassValue> = {
  // Styles for the select trigger button in dark mode
  darkTrigger: [
    'h-8 w-auto min-w-[118px] rounded-full border border-white/15 bg-slate-900/55 px-3', // Basic dimensions and reset
    'outline-none ring-0', // Remove default focus styles
    'focus:outline-none focus:ring-0', // Remove focus styles
    'focus-visible:outline-none focus-visible:ring-0', // Remove keyboard focus styles
    'data-[state=closed]:bg-slate-900/55', // Keep bg transparent when closed
    'data-[state=open]:bg-slate-900/70', // Keep bg transparent when open
    '[&:not(:focus-visible)]:shadow-none', // Remove shadow when not keyboard focused
    'cursor-pointer text-slate-200 transition-colors hover:border-primary-400/40 hover:text-white', // Text color and hover state
    'group', // Enable group hover effects
  ],

  // Styles for the dropdown content panel in dark mode
  darkContent:
    'w-[140px] rounded-xl border border-white/10 bg-slate-900/95 p-1 shadow-[0_16px_40px_-30px_rgba(2,6,23,1)] backdrop-blur', // Dropdown panel styling

  // Styles for individual dropdown items in dark mode
  darkItem: [
    'rounded-md px-3 py-2 text-sm text-slate-300', // Item padding and text
    'hover:bg-white/10 hover:text-white', // Item hover state
    'focus:bg-white/10 focus:text-white', // Item focus state
    'cursor-pointer', // Show clickable cursor
  ],

  // Styles for dropdown content within forms (like darkContent but without fixed width)
  formContent:
    'rounded-xl border border-white/10 bg-slate-900/95 p-1 shadow-[0_16px_40px_-30px_rgba(2,6,23,1)] backdrop-blur',

  // Styles for dropdown items within forms (same as darkItem)
  formItem: [
    'rounded-md px-3 py-2 text-sm text-slate-300',
    'hover:bg-white/10 hover:text-white',
    'focus:bg-white/10 focus:text-white',
    'cursor-pointer',
  ],

  // Styles for links within the select in dark mode
  darkLink: [
    'inline-flex items-center rounded-full px-2.5 py-1 text-sm font-medium text-slate-300 transition-colors', // Link text styling
    'hover:bg-white/10 hover:text-white', // Link hover state
    'cursor-pointer', // Show clickable cursor
  ],
} as const;
